
import React, { useState } from 'react';
import blogData from '../data/blogData';
import { Link } from 'react-router-dom';
import '../styles/Blog.css';

const BlogPage = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredBlogs = blogData.filter((blog) =>
    blog.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      className="blog-page"
      style={{
        backgroundImage: 'url("/blog-background.jpg")',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        paddingTop: '2rem',
      }}
    >
      <h1 className="blog-heading">📚 TravXplo Travel Blog</h1>
      <input
        type="text"
        placeholder="Search blogs..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="search-bar"
      />

      <div className="blog-grid">
        {filteredBlogs.map((blog) => (
          <Link
            to={`/blogs/${blog.id}`}
            state={{ blog }}
            key={blog.id}
            className="blog-card-link"
          >
            <div className="blog-card">
              <img src={blog.image} alt={blog.title} className="blog-img" />
              <div className="blog-card-content">
                <h3>{blog.title}</h3>
                <span className="read-link">Click to Read →</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
